import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './components/header/header.component';
import { LoadingComponent } from './components/loading/loading.component';
import { StoreModule } from '@ngrx/store';
import { appReducers } from './store/reducers/app.reducers';
import { FooterModule } from './components/footer/footer.module';
import { MatDialogModule } from '@angular/material/dialog';
@NgModule({
  declarations: [HeaderComponent, LoadingComponent],
  imports: [
    CommonModule,
    FooterModule,
    MatDialogModule,
    StoreModule.forRoot(appReducers)
  ],
  exports: [HeaderComponent, LoadingComponent, FooterModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule {}
